import { useContext } from 'react'
import { useForm } from 'react-hook-form'

import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { isEmailValid } from '@marketplace-web/registration/email-validation-feature'

import { Submit } from '../NotReceiveEmail/types'
import { validateEmail } from '../utils'
import Context from '../EmailVerificationCodeContext'

type FormData = {
  email: string
}

const useEmailForm = () => {
  const { email: userEmail, sendEmailCode } = useContext(Context)
  const feEmailValidationAbTest = useAbTest('fe_email_validation')
  const isFeEmailValidationEnabled = feEmailValidationAbTest?.variant === 'on'
  const translate = useTranslate('email_verification_code.not_receive_email.inputs.email')

  useTrackAbTest(feEmailValidationAbTest)

  const {
    register,
    getValues,
    formState: { errors },
  } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      email: userEmail || '',
    },
  })

  const handleSubmit = ({ useOldEmail }: Submit = {}) => {
    let { email } = getValues()

    if (useOldEmail && userEmail) {
      email = userEmail
    }

    sendEmailCode(email)
  }

  const getErrorMessage = (value: string) => {
    if (isFeEmailValidationEnabled) {
      return isEmailValid(value) ? undefined : translate('invalid_email')
    }

    return validateEmail(value)
  }

  return {
    register: register('email', {
      required: true,
      validate: value => getErrorMessage(value),
    }),
    getValues,
    handleSubmit,
    errors,
  }
}

export default useEmailForm
